var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":"请选择机构","clearable":""},on:{"change":_vm.onChage},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.sgsId,attrs:{"label":item.sgsName,"value":item.sgsId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }